module.exports = __webpack_public_path__ + "img/manu.451b9ce0.jpg";